module.exports = __webpack_public_path__ + "static/media/player_bg_ancient.2f4a0b78.png";